import request from '@/utils/request';

export interface AgencyApplyData {
  company_name: string;
  legal_person: string;
  phone: string;
  id_card_front: string;
  id_card_back: string;
  license_img: string;
  company_desc?: string;
}

export const getAgencyStatus = () => {
  return request({
    url: '/agency/status',
    method: 'GET'
  });
};

export const submitAgencyApply = (data: AgencyApplyData) => {
  return request({
    url: '/agency/apply',
    method: 'POST',
    data
  });
};

export const updateAgencyInfo = (data: { partners_info?: any[], company_desc?: string }) => {
  return request({
    url: '/agency/info',
    method: 'PUT',
    data
  });
};

export interface AgencyConfig {
  fees?: Record<string, number>;
  bonus_templates?: any[];
}

export const updateAgencyConfig = (data: AgencyConfig) => {
  return request({
    url: '/agency/config',
    method: 'PUT',
    data
  });
};

export interface SendCodeParams {
  phone: string
}

export function sendCustomerCode(params: SendCodeParams) {
  return request({
    url: '/customer/auth/send-code',
    method: 'POST',
    params // query params for send-code
  })
}

export const getInviteInfo = (params: { referrer_id?: string }) => {
  return request({
    url: '/agency/invite/info',
    method: 'GET',
    params
  });
};

export const getOfficialAgencyInfo = () => {
  return request({
    url: '/agency/official-info',
    method: 'GET'
  });
};

export const getAgencyApplications = (params: { page: number; page_size: number; status?: string; keyword?: string }) => {
  return request({
    url: '/agency/application/list',
    method: 'GET',
    params
  });
};

export const getMyAgencyApplications = (params: { page: number; page_size: number; status?: string }) => {
  return request({
    url: '/agency/application/my',
    method: 'GET',
    params
  });
};

export const auditAgencyApplication = (id: number, data: { status: string; remark?: string }) => {
  return request({
    url: `/agency/application/${id}/audit`,
    method: 'PUT',
    data
  });
};

export interface PageResponse<T> {
  items: T[];
  total: number;
  page: number;
  size: number;
}

export const getTeamMembers = (params: { page: number; page_size: number; keyword?: string; level?: string; parent_id?: string | number; exclude_virtual?: boolean }) => {
  return request({
    url: '/agency/team/members',
    method: 'GET',
    params
  }) as Promise<PageResponse<any>>;
};

export const getTeamMemberDetail = (id: number) => {
  return request({
    url: `/agency/team/members/${id}`,
    method: 'GET'
  });
};

export const getPerformanceStats = (params: any) => {
  return request({
    url: '/agency/performance/stats',
    method: 'GET',
    params
  });
};

export const getPerformanceTrace = (params: any) => {
  return request({
    url: '/agency/performance/trace',
    method: 'GET',
    params
  });
};

export const getAgencyWallet = () => {
  return request({
    url: '/agency/wallet',
    method: 'GET'
  });
};

export const getTeamStats = () => {
  return request({
    url: '/agency/team/stats',
    method: 'GET'
  });
};
